
export default function InViocePDFTemplate({invoice}) {
  return `
<div id="invoice">
<style>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>
<h2 style="font-weight: bold; text-align: center; text-decoration: underline;">INVOICE</h2>
<p style="font-weight: bold">NATIVE ROOTS RETAIL PRIVATE LIMITED<br/>
No.53, Kaveri Layout, Hebbal, Kempapura<br/>
 Bangalore North, Bangalore - 560024, Karnataka<br/>
  Phone : +91 96069 98203<br/>
 GSTIN : 29AAJCN5033E1ZH
 </p></br>

<table style="width: 100%; max-width: 900px;">
  <tr>
    <td colspan="7" style="font-weight: bold">Details of Receiver</td>
    <td colspan="2" style="font-weight: bold">Date</td>
    <td colspan="5">${invoice?.createdAt}</td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold">Name</td>
    <td colspan="5">${invoice?.customerName}</td>
    <td colspan="2" style="font-weight: bold">EInvoice #</td>
    <td colspan="5">${invoice?._id}</td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold">Address</td>
    <td colspan="5">${invoice?.deliveryAddress?.details},${invoice?.deliveryAddress?.deliveryAddress}</td>
    <td colspan="7">Phone: ${invoice?.customerPhone}</td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold">State</td>
    <td colspan="5">Karnataka</td>
    <td colspan="7"></td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold">State code</td>
    <td colspan="5"></td>
    <td colspan="7"></td>
  </tr>
  <tr>
    <td colspan="2" style="font-weight: bold">GSTIN</td>
    <td colspan="5">${invoice?.customerGST}</td>
    <td colspan="2" style="font-weight: bold">Order Id: </td>
    <td colspan="5">${invoice?.orderId}</td>
  </tr>
  <tr>
    <td colspan="14"><br/></td>
  </tr>
  <tr height=16>
    <td rowspan=2 height=32 class=xl80 width=31 style='height:25.5pt;border-top:none;width:23pt;font-weight: bold'>SL NO</td>
    <td rowspan=2 class=xl80 width=116 style='border-top:none;width:87pt;font-weight: bold'>Description of Goods</td>
    <td rowspan=2 class=xl80 width=56 style='border-top:none;width:42pt;font-weight: bold'>HSN Code</td>
    <td rowspan=2 class=xl80 width=35 style='border-top:none;width:26pt;font-weight: bold'>Ord Qty</td>
    <td rowspan=2 class=xl80 width=52 style='border-top:none;width:39pt;font-weight: bold'>Units</td>
    <td rowspan=2 class=xl80 width=59 style='border-top:none;width:44pt;font-weight: bold'>Rate</td>
    <td rowspan=2 class=xl80 width=71 style='border-top:none;width:53pt;font-weight: bold'>Total</td>
    <td rowspan=2 class=xl80 width=71 style='border-top:none;width:53pt;font-weight: bold'>Discount</td>
    <td rowspan=2 class=xl80 width=71 style='border-top:none;width:53pt;font-weight: bold'>Total</td>
    <td colspan=2 class=xl80 width=107 style='border-left:none;width:80pt;font-weight: bold'>CGST</td>
    <td colspan=2 class=xl80 width=107 style='border-left:none;width:80pt;font-weight: bold'>SGST</td>
  </tr>
  <tr height=16>
    <td height=16 class=xl67 width=44 style='height:12.75pt;border-top:none;border-left:none;width:33pt'>Rate</td>
    <td class=xl67 width=63 style='border-top:none;border-left:none;width:47pt;font-weight: bold'>Amount</td>
    <td class=xl67 width=44 style='border-top:none;border-left:none;width:33pt;font-weight: bold'>Rate</td>
    <td class=xl67 width=63 style='border-top:none;border-left:none;width:47pt;font-weight: bold'>Amount</td>
  </tr>

  ${invoice?.items?.map((item, index) => `
  <tr height=33>
    <td height=33 class=xl65 align=right style='height:25.5pt;border-top:none'>${index + 1}</td>
    <td class=xl68 width=116 style='border-top:none;border-left:none;width:87pt'>${item?.name}</td>
    <td class=xl66 width=56 style='border-top:none;border-left:none;width:42pt'>${item?.hsn}</td>
    <td class=xl69 style='border-top:none;border-left:none'>${item?.quantity}</td>
    <td class=xl69>${item?.unit}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${item?.taxableValue}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${item?.cost}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${item?.discount}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${item?.costAfterDiscount}</td>
    <td class=xl71 align=right style='border-top:none;border-left:none'>${item?.CGST.rate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${item?.CGST.amount}</td>
    <td class=xl71 align=right style='border-top:none;border-left:none'>${item?.SGST.rate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${item?.SGST.amount}</td>
  </tr>
  `).join('')}

   <tr height=16 >
    <td height=33 class=xl65 align=right style='height:25.5pt;border-top:none'>${invoice?.items?.length+1}</td>
    <td class=xl68 width=116 style='border-top:none;border-left:none;width:87pt'>ShippingCharge</td>
    <td class=xl70 align=right style='border-top:none;border-left:none;'>${invoice?.billDetails?.shippingCharges.HSN}</td>
    <td class=xl69 style='border-top:none;border-left:none'>1</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'></td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.Rate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.Total}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'></td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.Total}</td>
    <td class=xl71 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.CGSTRate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.CGSTAmount}</td>
    <td class=xl71 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.SGSTRate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.shippingCharges.SGSTAmount}</td>
  </tr>
  <tr height=16 >
    <td height=33 class=xl65 align=right style='height:25.5pt;border-top:none'>${invoice?.items.length+2}</td>
    <td class=xl68 width=116 style='border-top:none;border-left:none;width:87pt'>HandlingCharge</td>
    <td class=xl70 align=right style='border-top:none;border-left:none;'>${invoice?.billDetails?.handlingCharges.HSN}</td>
    <td class=xl69 style='border-top:none;border-left:none'>1</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'></td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.Rate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.Total}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'></td>

    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.Total}</td>
    <td class=xl71 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.CGSTRate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.CGSTAmount}</td>
    <td class=xl71 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.SGSTRate}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.handlingCharges.SGSTAmount}</td>
  </tr>


  <tr height=16 >
    <td colspan=8 height=16 class=xl79 style='height:12.75pt; text-align: right' >Total</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'>${invoice?.billDetails?.totalCost}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'></td>
    <td class=xl70 align=right style='border-left:none'>${invoice?.billDetails?.totalCGST}</td>
    <td class=xl70 align=right style='border-top:none;border-left:none'></td>
    <td class=xl70 align=right style='border-left:none'>${invoice?.billDetails?.totalSGST}</td>
  </tr>
  <tr height=16 >
    <td colspan=8 height=16 class=xl72 style='height:12.75pt;font-weight: bold;text-align: right'>Total Invoice Value(in figures)</td>
    <td colspan=6 class=xl77 align=right style='border-left:none;font-weight: bold'>${invoice?.billDetails?.grandTotal}</td>
  </tr>
  <tr height=16 >
    <td colspan=8 height=16 class=xl72 style='height:12.75pt;font-weight: bold;text-align: right'>Total Invoice Value(in words)</td>
    <td colspan=6 class=xl75 width=356 style='border-left:none;width:266pt;font-weight: bold;text-align: right'>${invoice?.billDetails?.words}</td>
  </tr>
</table>
</div>
`;

};


